import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import leftBanner from "./assets/left-banner.png";
import rightBanner from "./assets/right-banner.png";


const EmployeeHero = () => {
    const navigate = useNavigate();
    return (
  <section className="relative w-full bg-[#1E72BB] overflow-hidden">

  <img
    src={leftBanner}
    alt="Left Banner"
    className="
      hidden lg:block absolute left-0 bottom-0 
      w-[28vw] max-w-[420px] min-w-[260px]
      pointer-events-none
    "
  />

  <img
    src={rightBanner}
    alt="Right Banner"
    className="
      hidden lg:block absolute right-0 bottom-0
      w-[28vw] max-w-[420px] min-w-[260px]
      pointer-events-none
    "
  />

  <div
    className="
      relative z-10 flex flex-col items-center text-center
      px-5 sm:px-6 md:px-8
      pt-10 sm:pt-12 md:pt-14 lg:pt-16 
      pb-14 sm:pb-18 md:pb-20 lg:pb-24
      max-w-3xl mx-auto
    "
  >
    <h1
    className="text-white font-bold leading-[1.2]
               mb-[clamp(16px,4vw,24px)]
               text-[clamp(28px,6vw,44px)]"
  >
    Employee Self Service <br />
  </h1>

  <p
    className="text-white opacity-95 leading-[1.6]
               max-w-[700px] mx-auto
               mb-[clamp(20px,4vw,32px)]
               text-[clamp(15px,2.8vw,16px)]"
  >
    Employee Self-Service empowers staff to manage schedules, leave, 
    and personal tasks independently with ease. It centralizes leave 
    management and automates approvals, improving efficiency and 
    work-life balance.
  </p>

     <motion.button
    whileHover={{
      scale: 1.08,
      backgroundColor: "#ffffff",
      color: "#000000",
      boxShadow: "0 0 20px rgba(255,255,255,0.6)",
    }}
    whileTap={{ scale: 0.95 }}
    transition={{ duration: 0.3, ease: "easeOut" }}
    className="font-epilogue bg-white text-[#1E72BB]
               font-bold py-[14px] px-[36px]
               rounded-[30px] 
               text-[clamp(15px,1.2vw,17px)]
               cursor-pointer"
    onClick={() => navigate("/schedule-a-demo")}
  >
    Schedule a Demo
  </motion.button>
  </div>
</section>
    );
};

export default EmployeeHero;